
import { defineComponent } from "vue";
import { mapActions, mapGetters } from "vuex";
import PagerItem from "@/components/pager/PagerItem.vue";

export default defineComponent({
    name: "Pager",
    components: {PagerItem},
    computed: mapGetters({
        pager: 'getPager',
        nextPageUrl: 'getNextPageUrl',
        nextPageLabel: 'getNextPageLabel',
        backToTopLabel: 'getBackToTopLabel'
    }),
    setup() {
        const scrollTop = (): void => {
            window.scrollTo({ top: 0, left: 0, behavior: 'smooth' });
        }

        return {
            scrollTop
        }
    },
    methods: {
        ...mapActions({
            loadProducts: 'LOAD_PRODUCTS'
        }),
        loadMore(url: string) {
            this.loadProducts({url: url, appendProducts: true})
        }
    }
});
